var version = require("./version")

module.exports = isVirtualText

function isVirtualText(x) {
    return x && x.type === "VirtualText" && x.version === version
}



//////////////////
// WEBPACK FOOTER
// ./~/virtual-hyperscript/~/vtree/is-vtext.js
// module id = 199
// module chunks = 0